import type { CanonicalExperienceCapability } from "./canonicalExperienceContext";

export type CanonicalExperienceOutput =
  CanonicalExperienceCapability["allowedOutputs"][number];

/**
 * The server owns both sides of the capability boundary. A consumer may use
 * an output only when it is explicitly allowed and not explicitly prohibited.
 */
export function canProduceCanonicalExperienceOutput(
  capability: CanonicalExperienceCapability,
  output: CanonicalExperienceOutput,
): boolean {
  return (
    capability.allowedOutputs.includes(output) &&
    !capability.prohibitedOutputs.includes(output)
  );
}
